
<div *ngIf="sitemapContent && !isLoading" class="sitemap-preview">
    <!--<pre><code>{{ sitemapContent }}</code></pre>-->
    <a href="#" (click)="downloadSitemap()">Sitemap</a>
</div>